import { useHistory } from 'react-router-dom';
import { FC, useState, useEffect } from 'react';
import styles from './styles.module.css';
import { SecretaryCard } from '../secretary-card/secretary-card';

interface SecretaryCardData {
  name: string;
  shortName: string;
  image: string;
  location?: string;
  date?: string;
  phone1: string;
  phone2: string;
  link: string;
  slug: string;
}

interface SecretaryCardListProps {
  cards: SecretaryCardData[];
  redirect: (link: string) => void;
}

const getCardsPerRow = (): number => {
  if (typeof window === 'undefined') return 5;
  if (window.innerWidth <= 480) return 2;
  if (window.innerWidth <= 768) return 2;
  if (window.innerWidth <= 1100) return 3;
  if (window.innerWidth <= 1400) return 4;
  return 5;
};

const getCardColor = (index: number): string => {
  const colors = ['#3A5FB9', '#4B4FA9', '#5B3F99', '#723B89', '#893779'];
  const cardsPerRow = getCardsPerRow();
  const positionInRow = index % cardsPerRow;
  return colors[positionInRow];
};

export const SecretaryCardList: FC<SecretaryCardListProps> = ({
  cards,
  redirect,
}) => {
  const history = useHistory();
  const [, forceUpdate] = useState({});

  useEffect(() => {
    const handleResize = () => forceUpdate({});
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={styles.cardList}>
      {cards.map((card, index) => {
        const href = history.createHref({
          pathname: `/secretarias-e-orgaos/${card.slug}`,
        });

        return (
          <a
            key={index}
            href={href}
            onClick={(e) => {
              
              if (
                e.button !== 0 || 
                e.metaKey ||
                e.ctrlKey ||
                e.shiftKey ||
                e.altKey
              ) {
                return; 
              }

              e.preventDefault();      
              redirect(card.slug);     
            }}
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <SecretaryCard
              title={card.shortName}
              subtitle={card.name}
              backgroundColor={getCardColor(index)}
            />
          </a>
        );
      })}
    </div>
  );
};
